/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React from 'react'
import { Container } from './styles'
import { transformDate } from '~/utils'

interface ModalHeaderProps {
  title?: string
  datetime?: string
}

const ModalHeader = ({ title, datetime }: ModalHeaderProps): JSX.Element => {
  return (
    <Container>
      <div className="header">{title || 'Não informado'}</div>
      <div className="timestamp">
        <span>{datetime ? transformDate({ date: datetime, withHourAndMinute: true }) : 'Não informado'}</span>
      </div>
    </Container>
  )
}

export { ModalHeader }
